import { Component, computed, EventEmitter, inject, input, Output, ResourceRef } from '@angular/core';
import { AtlasLanguageService, LanguageMapping } from '../../../../../../core/src';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { rxResource } from '@angular/core/rxjs-interop';
import { translations } from '@galaxy/lexicon';

@Component({
  selector: 'atlas-language-list-item',
  templateUrl: './language-list-item.component.html',
  styleUrls: ['./language-list-item.component.scss'],
  standalone: false,
})
export class LanguageListItemComponent {
  languageService = inject(AtlasLanguageService);
  translateService = inject(TranslateService);
  translateLoader = inject(TranslateLoader);

  language = input.required<LanguageMapping>();
  @Output() languageSelected: EventEmitter<string> = new EventEmitter<string>();

  translationStream = rxResource({
    request: () => this.language(),
    loader: ({ request: language }) =>
      this.translateService.stream(`LANGUAGE.${language.code.toLowerCase()}` || language.label),
  });

  loadedTranslations: ResourceRef<translations> = rxResource({
    request: () => this.language(),
    loader: ({ request: language }) => this.translateLoader.getTranslation(language.code),
  });

  labelsTarget = computed(() => {
    const targetTranslation = this.loadedTranslations.value();
    const language = this.language();

    let target: string | translations = '';
    if (targetTranslation) {
      target = targetTranslation?.['LANGUAGE']?.[language.code.toLowerCase()] ?? '';
      if (typeof target === 'string') {
        return target;
      }
    }
  });

  languageLabels = computed(() => {
    return { current: this.translationStream.value(), target: this.labelsTarget() };
  });

  isCurrentLanguage = this.languageService.language$.pipe(map((language) => language === this.language().code));

  selectLanguage(): void {
    this.languageSelected.emit(this.language().code);
  }
}
